import React from "react";

export default function TextFieldIcon() {
  return (
    <div style={{ marginLeft: "10px" }}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.8 0.75H1.2C0.813401 0.75 0.5 1.0634 0.5 1.45V2.38C0.5 2.7666 0.813401 3.08 1.2 3.08C1.5866 3.08 1.9 2.7666 1.9 2.38V2.15H7.3V13.85H7.07C6.6834 13.85 6.37 14.1634 6.37 14.55C6.37 14.9366 6.6834 15.25 7.07 15.25H8.93C9.3166 15.25 9.63 14.9366 9.63 14.55C9.63 14.1634 9.3166 13.85 8.93 13.85H8.7V2.15H14.1V2.38C14.1 2.7666 14.4134 3.08 14.8 3.08C15.1866 3.08 15.5 2.7666 15.5 2.38V1.45C15.5 1.0634 15.1866 0.75 14.8 0.75Z"
          fill="#12344D"
        />
      </svg>
    </div>
  );
}
